import { render, staticRenderFns } from "./CrmManagementDashboard.vue?vue&type=template&id=9ab9e0cc&scoped=true"
import script from "./CrmManagementDashboard.vue?vue&type=script&lang=js"
export * from "./CrmManagementDashboard.vue?vue&type=script&lang=js"
import style0 from "./CrmManagementDashboard.vue?vue&type=style&index=0&id=9ab9e0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab9e0cc",
  null
  
)

export default component.exports